import { useGetIntegrationRequestByIdQuery } from '../../services';
import { LoaderBackdrop, NavigateLinks } from '@/components';
import { useIntegrationRequestBreadcrumbs } from './hooks';
import { IntegrationRequestDetail } from './components';
import { useParams } from 'react-router-dom';

const IntegrationRequestDetailPage = () => {
  const { requestId = '' } = useParams<{ requestId: string }>();
  const breadcrumbs = useIntegrationRequestBreadcrumbs();
  const { data: request, isLoading } = useGetIntegrationRequestByIdQuery(requestId, {
    skip: !requestId,
  });

  if (isLoading) return <LoaderBackdrop />;

  return (
    <section className='flex flex-col gap-6 w-full h-full pb-10'>
      <NavigateLinks actualPage='Solicitud de integración' breadcrumbs={breadcrumbs} />
      {request ? (
        <IntegrationRequestDetail request={request} />
      ) : (
        <p className='text-sm text-red-600'>No se encontró la solicitud.</p>
      )}
    </section>
  );
};

export default IntegrationRequestDetailPage;
